export const API_URL = '/api'
export const CLIENT_ID = '1_4qf390tgjwo40k088s8sw4gk8gwgcs8w0ccswwok84cko80os8'
export const CLIENT_SECRET =
  '62lr2d8w56w44k4s0gs8gsg0k0wsc4s804ck0880g80o408c4c'



// WEBPACK FOOTER //
// ./src/api/const.js